export default __webpack_public_path__ + "static/media/9.7d906c88.jpg";